import { Route, Routes } from "react-router-dom";
import React from "react";
import EmailSettings from "../pages/app/Inbound/components/Settings/EmailSettings/EmailSettings";
import ImportSettings from "../pages/app/Inbound/components/Settings/ImportSettings/ImportSettings";
import { getSubDomainAccessStatus } from "../components/RolePermissionAccess/RolePermissionAccess";
import { useSelector } from "react-redux";
import NoAccess from "../components/NoAccess/NoAccess";

export default function ManageInboundSettingsRouter(props: any) {
  const { userById } = useSelector((state: any) => state.userDetails);

  const importAccess = getSubDomainAccessStatus(
    "INBOUND",
    "IMPORT",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const emailAccess = getSubDomainAccessStatus(
    "INBOUND",
    "EMAIL",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  return (
    <Routes>
      <Route
        path={"/"}
        element={emailAccess ? <EmailSettings /> : <NoAccess />}
      />
      <Route
        path={"/Email"}
        element={emailAccess ? <EmailSettings /> : <NoAccess />}
      />
      <Route
        path={"/Import"}
        element={importAccess ? <ImportSettings /> : <NoAccess />}
      />
      <Route
        path={"/ImportSetting"}
        element={importAccess ? <ImportSettings /> : <NoAccess />}
      />
      {/* <Route
        path={"/WhatsApp"}
        element={
          importAccess ? (
            <WhatsAppSettings
              whatsappConfigInstituteData={whatsappConfigInstituteData}
              {...props}
            />
          ) : (
            <NoAccess />
          )
        }
      /> */}
    </Routes>
  );
}
